var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// utils
import { PartnerServiceEndpoints } from '@/constants/endpoints';
import { getPartnerServiceBasePath } from '@/helpers/endpoints';
import { readFromLocalStorage } from '@/helpers/storage';
import HttpClient from '@/includes/httpClient';
import { RequestHeaderKeys } from '@local/typedefs/dist/common/headers';
// constants
import { localStorageKeys } from '@/constants/storage';
export const getPermissionsApi = (_a) => __awaiter(void 0, [_a], void 0, function* ({ accountId, }) {
    try {
        const url = `${getPartnerServiceBasePath()}${PartnerServiceEndpoints.ACCOUNT_PERMISSIONS}`;
        const accessToken = yield readFromLocalStorage(localStorageKeys.ACCESS_TOKEN);
        const headers = {
            Authorization: `Bearer ${accessToken}`,
            [RequestHeaderKeys.X_CLIENT_ACCOUNT_ID]: accountId || '',
        };
        const result = yield HttpClient.get(url, {}, headers);
        return result.data;
    }
    catch (err) {
        if (__DEV__) {
            console.log(err);
        }
        throw err;
    }
});
